module.exports = __webpack_public_path__ + "img/hero_sp.b463639f.jpg";